export * from './loyalty-background.styled.default';
